import React from 'react';
import Helmet from 'react-helmet';

import './index.scss';

const Home = () => {
	return (
		<main className={'home'}>
			<Helmet bodyAttributes={{class: 'page-home'}} />
			<div className={'wrapper'}>
				<div className={'panel first'}></div>
				<div className={'panel second'}></div>
				<div className={'panel third'}></div>
				<div className={'panel fourth'}></div>
			</div>
		</main>
	);
};

export default Home;



// WEBPACK FOOTER //
// ./src/pages/index.jsx